import React, { CSSProperties, FC, useState } from 'react';

import { IVideo } from '../../../common/messageCreators';
import { MessageItem } from '../MessageItem';
import { PlayButton } from './PlayButton';
import s from './styles.scss';
import { Youtube } from './Youtube';

export const Video: FC<IVideo> = ({ id, videoId, avatar }) => {
  const [isPlay, setState] = useState<boolean>(false);

  const styles: CSSProperties = {
    backgroundImage: `url(https://i.ytimg.com/vi/${videoId}/hqdefault.jpg)`,
  };

  const play = () => {
    setState(true);
    // TODO: add BI event
    // bi('play-video');
  };

  return (
    <MessageItem id={id}>
      <article className={s.box}>
        <div className={s.video} style={styles}>
          {isPlay ? <Youtube videoId={videoId} /> : <PlayButton onClick={play} />}
        </div>
      </article>
    </MessageItem>
  );
};
